'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { FormFields, formSchema } from './formTypes';
import { purchaseFormCtx } from './purchaseFormCtx';

type UseInitPurchaseFormProps = {
    defaultValues: FormFields;
};

export const useInitPurchaseForm = ({ defaultValues }: UseInitPurchaseFormProps) => {
    return useForm<FormFields>({
        defaultValues,
        formControl: purchaseFormCtx,
        resolver: zodResolver(formSchema),
    });
};
